<template>
  <body>
    <div>
      <fy-form :model="appInvoiceInfo" :rules="rules" ref="form" v-if="!isInit">
    <div>
        <p>发票类型：<span class="doc_gray">电子普通发票</span></p>
    <div>
      <p>发票内容:
          <select class="doc_content" v-model.trim="doc_content">
            <option value=""></option>
            <option v-for="(option,index) in docContentList" :value="option.category" :key="index">
              {{  option.category }}
            </option>
          </select>
        </p>
          <!-- <p>发票内容
          <fy-select
          :options="docContentList"
          labelKey="category"
          v-model="appInvoiceInfo.doc_content"
          valueKey="category_code"
          class="doc_content"
        ></fy-select>
        </p> -->
    </div>
    <div>
      <p>发票金额：<span class="amount">￥{{ this.amount }}</span></p>
    </div>
    <div>
      <p>
        <input type="radio" id="person"  class="rad" v-model="invoiceBelongType" checked="checked" value="0" /><label for="person"></label>个人
        &nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" id="company" class="rad" v-model="invoiceBelongType" value="1" /><label for="company"></label>单位
      </p>
    </div>
     <p><span class="required">*</span>购买方名称：
    <fy-form-item :prop="fields.head.field_enname">
      <fy-input
            :placeholder="fields.head.field_placeholder"
            type="text"
            v-model.trim="appInvoiceInfo.head"
        ></fy-input>
    </fy-form-item>
     </p>
     <div v-if="invoiceBelongType==1">
      <p><span class="required">*</span>纳税人识别号：
        <fy-form-item :prop="fields.taxpayer_code.field_enname">
        <fy-input
            :placeholder="fields.taxpayer_code.field_placeholder"
            type="text"
            v-model.trim="appInvoiceInfo.taxpayer_code"
        ></fy-input>
    </fy-form-item>
     </p>
     </div>
     <div v-if="isShowContact">
     <p><span class="required">*</span>取票人姓名：
    <fy-form-item :prop="fields.contact_person2.field_enname">
      <fy-input
            :placeholder="fields.contact_person2.field_placeholder"
            type="text"
            v-model.trim="appInvoiceInfo.contact_person2"
        ></fy-input>
    </fy-form-item>
     </p>
     <p><span class="required">*</span>取票人电话：
    <fy-form-item :prop="fields.contact_person2_tel.field_enname">
      <fy-input
            :placeholder="fields.contact_person2_tel.field_placeholder"
            type="text"
            v-model.trim="appInvoiceInfo.contact_person2_tel"
        ></fy-input>
    </fy-form-item>
     </p>
    </div>
      </div>
    </fy-form>
    <div>
        <p class="btn">
          <input type="button" value="下一步" class="invoice_next" @click="next()"/> 
        </p>
      </div>
    </div>
  </body>
</template>
<style scoped>
/* @import '../../assets/css/pages/customer/css.css'; */
  body{
    background: #eee;
    font-family:Microsoft YaHei;
    font-size: 1.5em;
  }
  p {
    line-height: 300%;
    padding-left: 15%;
    font-size: 1em
  }
  .amount {
      color: #0096FF;
  }
  .doc_gray{
    color: rgba(94, 90, 90, 0.664);
  }
  .required {
      color: #f00;
  }
  .doc_content {
      width: 50%;
      font-size: 0.7em;
      background-color: white;
  }
  .inp {
      font-size: 0.7em;
      width: 60%;
      height: 25px;
  }
  .btn {
      margin-top: 2%;
      padding-left: 0;
      text-align: center;
      border: 0;
  }
  .invoice_next{
      background-color: #5595e3;
      border-radius: 5px;
      width: 90px;
      font-size: 10px;
      padding: 1% 1%;
      color: #fff;
  }
  .rad {
    display: none;
  }
  .rad + label {
      background-color: #FFF;
      border: 1px solid #C1CACA;
      padding: 8px;
      border-radius: 10px;
      display: inline-block;
      position: relative;
      margin-right: 5px;
  }
  .rad:checked + label {
      background-color: #757575;
  }
  select {
      width:100px;
      -webkit-appearance: none;
      background: url("~@/assets/images/html/bottom_arrow_03.png") 90% 50% no-repeat;
      background-size: 20px 10px;
      height: 30px;
      padding-left: 5px;
  }
</style>
<script>
export default {
    data() {
        return{
            invoiceBelongType: 0,
            docContentList: [],
            isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
            ids:[],
            rules: {},
            fields: {},
            doc_content:'', //发票内容
            isShowContact: false,  //销售开票时控制是否显示取票人和取票人电话
            appInvoiceInfo:{
               contact_person2:'',    //取票人姓名
               contact_person2_tel:'', //取票人电话
               head: '',   // 抬头
               taxpayer_code: '', //纳税人识别号
            }
        }
    },
    props: {
      order_id: {
        type: String,
      },
      amount: {
        type: String,
      },
      source:{
        type: String,
      },
    },
    created(){
        if(this.order_id == undefined) {
          this.$msg('订单号异常','error')
          return
        }
        this.getDocContent()

        this.$pageField.init(this, 'fields', 'invoiceAppInfo').then(res => {
        this.isInit = false
    })
     },
     methods: {
         next() {
           if(this.doc_content == '' || this.doc_content == null) {
             this.$msg('请选择发票内容', 'error')
           } else {
             this.$refs.form.validate((valid, invalidFields)=> {
               if (valid) {
                 this.$sessionStorageUtil.set('amount', this.amount)
                 this.$sessionStorageUtil.set('head', this.appInvoiceInfo.head)
                 this.$sessionStorageUtil.set('source', this.source)
                 this.$sessionStorageUtil.set('doc_content', this.doc_content)
                 this.$sessionStorageUtil.set('invoiceBelongType', this.invoiceBelongType)
                 this.$sessionStorageUtil.set('taxpayer_code_inp', this.appInvoiceInfo.taxpayer_code)
                 this.$sessionStorageUtil.set('contact_person2', this.appInvoiceInfo.contact_person2)
                 this.$sessionStorageUtil.set('contact_person2_tel', this.appInvoiceInfo.contact_person2_tel)
                 this.$domUtils.dispatch(this, 'Invoice', 'cut.invoice', { order_id: this.order_id, show_info: false, show_affirm: true , isShowContact: this.isShowContact })
               } else {
                 this.$msg(invalidFields[0].message, 'error')
               }
             })
           }
        },
         getDocContent() {
           const url = '/doc_app/get_doc_app_options'
           const params = {}
           var fields = this.$myGet(url, params)
           fields.then(res => {
             this.docContentList = res.response.data.doc_app_options
           })
           this.getLoingType()
         },
         getLoingType() {
           let type = this.$loginType()
           var ids = this.order_id.split(',')
           if (type == 0) {  //销售登录
             if (ids.length >= 2) { //批量开票
               this.isShowContact = true
             }
           }
         }
     }
}
</script>



// WEBPACK FOOTER //
// src/pages/common/invoiceAppInfo.vue